import { useUI } from "providers/UIProvider"

import SettingsLayout from "components/shared/layouts/SettingsLayout"

import CancellationFeeTabs from "./CancellationFeeTabs"
import CancellationFeeForm from "./CancellationFeeForm"

const BookingsSettingsTemplate = () => {
  const { T } = useUI()

  return (
    <SettingsLayout title={T("cancellation_fee.title")}>
      <>
        <CancellationFeeTabs />
        <CancellationFeeForm />
      </>
    </SettingsLayout>
  )
}

export default BookingsSettingsTemplate